import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetPivotTableDataRPC } from "./getPivotTableDataRPC";

export class GetPivotTableDataRPCClientImpl extends GetPivotTableDataRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetPivotTableDataRPC.Request): Promise<LeoRPCResult<GetPivotTableDataRPC.Response, GetPivotTableDataRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "project/GetPivotTableData",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetPivotTableDataRPC.ResponseDTO,
      GetPivotTableDataRPC.Errors.ErrorsDTO,
      GetPivotTableDataRPC.Response,
      GetPivotTableDataRPC.Errors.Errors
    >(
      response,
      "project/GetPivotTableData",
      GetPivotTableDataRPC.Response.fromDTO,
      GetPivotTableDataRPC.Errors.fromDTO
    );
  }
}
